import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  CategoryScale
} from "chart.js";

ChartJS.register(
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  CategoryScale
);

export default function ChartPanel({ history }) {

  if (!history || history.length === 0) {
    return (
      <div style={{ color: "#666", padding: 20 }}>
        no history
      </div>
    );
  }

  const labels = history.map(h =>
    new Date(h.time).toLocaleTimeString()
  );
  const temps = history.map(h => {
  if (h.temp < -50 || h.temp > 60) return null;
  return h.temp;
});

  const data = {
  labels,
  datasets: [
    {
      data: temps,
      spanGaps: false,

      borderColor: "#00e5ff",
      backgroundColor: "rgba(0,229,255,0.15)",
      borderWidth: 2,

      pointRadius: 3,
      pointHoverRadius: 6,
      pointBackgroundColor: "#00ffc3",
      pointBorderWidth: 0,

      fill: true
    }
  ]
};

 const options = {
  responsive: true,
  maintainAspectRatio: false,

  animation: {
    duration: 2000,
    easing: "easeInOutCubic"
  },

  elements: {
    line: {
      tension: 0.4,
      cubicInterpolationMode: "monotone"
    }
  },

  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "#111",
      titleColor: "#00e5ff",
      bodyColor: "#fff"
    }
  },

  scales: {
    x: {
      ticks: { color: "#888" },
      grid: { color: "rgba(255,255,255,0.05)" }
    },
    y: {
      ticks: { color: "#888" },
      grid: { color: "rgba(255,255,255,0.05)" }
    }
  }
};
    

  return (
    <div style={{
      height: "100%",
      padding: 15,
      background: "#000"
    }}>
      <Line data={data} options={options} />
    </div>
  );
}
